import Head from 'next/head';
import { TeaserProps } from '@/types/componentTypes';
import Teaser from '@/components/Teaser';
import { TeaserCode } from '@/components/codeHighlights/TeaserCode';
import images from '../../datas/teaser.json';

const Page = () => {
  const datas: TeaserProps[] = images.datas;

  return (
    <>
      <Head>
        <title>Teaser</title>
      </Head>

      <h1>Teaser</h1>

      <h2>Three columns teasers</h2>

      <div className="row">
        {datas &&
          datas.map((data, idx: number) => (
            <Teaser
              key={idx}
              datas={data}
              styles={'col-xs-12 col-sm-6 col-lg-4 p-0'}
            />
          ))}
      </div>

      <h2>Four columns teasers</h2>
      <div className="row">
        {datas &&
          datas.map((data, idx: number) => {
            return (
              <Teaser
                key={idx}
                datas={data}
                styles={'col-xs-12 col-sm-6 col-lg-3 p-0'}
              />
            );
          })}
      </div>
      <div className="mt-5">
        <TeaserCode />
      </div>
    </>
  );
};

export default Page;
